import PropTypes from 'prop-types';
import React from 'react';
import CommonStyles from '../Styles.module.scss';
import styles from './accountManagementView.module.scss';
import cx from 'classnames';
import { Col, Image, Row } from 'react-bootstrap';
import ImageEditor from 'src/legacy/components/ImageEditor/index.jsx';
import ImageTools from 'src/legacy/services/ImageTools';
import { DEFAULT_FONTS } from 'src/constants/fonts';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AccountSettings from './components/settings/account.jsx';
import CollectionSettings from './components/settings/collection.jsx';
import ShareSettings from './components/settings/share.jsx';
import { localizedStrings } from 'src/localization/index.jsx';
import userRoleService from 'src/services/userRoles.service';
import Button from 'src/components/button';
import { TabBar } from 'src/components/tabbar';
import _ from 'lodash';
import SwitchButton from 'src/components/switchButton';
import DealRoomSettings from './components/settings/dealRoom';

const favIcon = '/images/Paperflite.png';
class AccountManagementView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      ...this.props.account,
      updatedFavIcon: null,
      showHubAccessConfirmation: false,
      showGlobalContactsConfirmation: false,
      activeTab: 0,
      triggerRerender: false,
    }
    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this.onResetClick = this.onResetClick.bind(this);

    this._handleFavIconUpload = this._handleFavIconUpload.bind(this);

    this.handleAccountSettingsChange = this.handleAccountSettingsChange.bind(this);
    this.handleCollectionSettingsChange = this.handleCollectionSettingsChange.bind(this);
    this.handleShareSettingsChange = this.handleShareSettingsChange.bind(this);
    this.handleConentSettingsChange = this.handleConentSettingsChange.bind(this);
    this.handleDealRoomSettingsChange = this.handleDealRoomSettingsChange.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedAccountSettings = this.localizedSettings.account.account_management.tabs;
    this.localizedAccountSettingsList = localizedStrings.constants.accountSettings;
  }

  _handleFavIconUpload(e) {
    ImageTools.resize(e.target.files[0], {
      width: 196, // maximum width
      height: 196 // maximum height
    }, (blob, didItResize) => {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          favIcon: e.target.result
        });
      };

      reader.readAsDataURL(blob);
    });
  }

  _handleUpdateClick() {
    var collectionSettings = this.state.collectionSettings || {};
    if (collectionSettings) {
      const background = _.get(collectionSettings, 'banner.background');
      if (typeof background !== 'string') {
        collectionSettings = _.omit(collectionSettings, 'banner.background');
      }
    }

    var dealRoomSettings = this.state.dealRoomSettings || {};
    if (dealRoomSettings) {
      const background = _.get(dealRoomSettings, 'banner.background');
      if (typeof background !== 'string') {
        dealRoomSettings = _.omit(dealRoomSettings, 'banner.background');
      }
    }

    var shareSettings = this.state.shareSettings || {};

    var logo = this.state.logo;
    if (logo) {
      if (typeof logo !== 'string') {
        logo = null
      }
    }

    let account = {
      name: this.state.name,
      companyUrl: this.state.companyUrl,
      favIcon: this.state.updatedFavIcon,
      logo: logo,
      collectionSettings: collectionSettings,
      dealRoomSettings: dealRoomSettings,
      shareSettings: shareSettings,
      contentSettings: this.state.contentSettings || {}
    }

    this.props.updateAccount(account);

    this.setState({
      banner: null
    })
  }

  onResetClick() {
    this.setState({
      ...this.props.account,
      updatedFavIcon: null,
      triggerRerender: !this.state.triggerRerender,
    })
  }



  renderFavIcon() {

    if (this.props.account.favIcon) {
      favIcon = this.props.account.favIcon.full;
    }

    if (this.state.favIcon) {
      favIcon = this.state.favIcon
    }

    return favIcon
  }

  handleAccountSettingsChange(changes) {
    this.setState({
      ...changes
    })
  }

  handleCollectionSettingsChange(changes) {
    this.setState({
      collectionSettings: changes
    })
  }

  handleShareSettingsChange(field, value) {
    const shareSettings = this.state.shareSettings || {};
    this.setState({
      shareSettings: {
        ...shareSettings,
        [field]: value
      }
    }, () => {

    })
  }

  handleConentSettingsChange(key, value) {
    this.setState({
      contentSettings: {
        ..._.get(this,"state.contentSettings",{}),
        [key] : value
      }
    })
    
  }

  handleDealRoomSettingsChange(changes) {
    this.setState({
      dealRoomSettings: changes
    })
  }

  getFonts() {
    var fontArray = [...DEFAULT_FONTS];
    var customFonts = _.get(this.props, 'account.theme.fonts', []);

    if (customFonts && customFonts.length > 0) {
      fontArray = [...customFonts, ...fontArray];
    }

    return fontArray.map(font => {
      return `${font.name}=${font.fontFamily}`
    }).join(';');
  }

  render() {
    const { activeTab } = this.state;

    const collectionAccessible = userRoleService.canAccessCollection();
    const shareAccessible = userRoleService.canShare();
    const dealRoomsAccessible = userRoleService.canAccessDealRoom();

    const tabs = [
      { title: this.localizedAccountSettings.account_settings.title, disabled: false },
      { title: this.localizedAccountSettings.collection_settings.title, disabled: !collectionAccessible },
      { title: this.localizedAccountSettings.share_settings.title, disabled: !shareAccessible },
      { title: this.localizedAccountSettings.content_settings.title, disabled: !shareAccessible },
      { title: "Deal Room Settings", disabled: !dealRoomsAccessible },
    ];

    return (
      <div className={CommonStyles.rightContent}>
        <div className={styles.body}>
          <Tabs forceRenderTabPanel={true}>
            <TabBar
              gap={2}
              tabSize="equal"
              active={activeTab}
              onSelectionChange={(tab) => this.setState({ activeTab: tab })}
              className={styles.tabContainer}
            >
              {tabs.filter(tab => !tab.disabled).map((tab, index) => (
                <div
                  key={index}
                  className={`${styles.tab} ${activeTab === index ? styles.activeTab : ""
                    }`}
                >
                  {tab.title}
                </div>
              ))}
            </TabBar>

            <TabSection index={0} selected={this.state.activeTab}>
              <AccountSettings
                value={this.state}
                onChange={this.handleAccountSettingsChange}
              ></AccountSettings>
            </TabSection>

            <TabSection index={1} selected={this.state.activeTab}>
              <CollectionSettings
                account={this.props.account}
                value={this.state}
                onChange={this.handleCollectionSettingsChange}
              ></CollectionSettings>
            </TabSection>

            <TabSection index={2} selected={this.state.activeTab}>
              <ShareSettings
                value={this.state}
                onChange={this.handleShareSettingsChange}
              >
              </ShareSettings>
            </TabSection>

            <TabSection index={3} selected={this.state.activeTab}>
              <ContentSettings
                contentSettings={_.get(this,"state.contentSettings")}
                onChange={this.handleConentSettingsChange} />
            </TabSection>

            <TabSection index={4} selected={this.state.activeTab}>
              <DealRoomSettings
                triggerRerender={this.state.triggerRerender}
                account={this.props.account}
                value={this.state}
                onChange={this.handleDealRoomSettingsChange}
              />
            </TabSection>
          </Tabs>

          <div className={styles.buttonTray}>
            <Button
              variant='primary'
              text={this.props.updating ? `${this.localizedCommonsActions.saving}...` : this.localizedCommonsActions.save}
              disabled={this.props.updating}
              onClick={this._handleUpdateClick}
              icon="paperflite-tick"
            >
            </Button>
            <Button
              variant='secondary'
              text={this.localizedCommonsActions.reset}
              disabled={this.props.updating}
              onClick={this.onResetClick}>
            </Button>
          </div>
        </div>


        <ImageEditor className={styles.editor}
          show={this.state.file != null}
          image={this.state.file}
          onChange={this.onBannerUpload}
          onCancel={this.onUploadCancel}
          borderRadius={0}
          width={800}
          height={225} />
      </div>
    )
  }
}

AccountManagementView.contextTypes = {
  store: PropTypes.object
}

export default AccountManagementView;


const TabSection = ({ index, selected, children }) => {
  const active = index === selected;

  return (
    <div className={cx(styles.tabBody, styles.stack)}>
      {active && children}
    </div>
  );
}

const ContentSettings = ({ contentSettings, onChange }) => {

  const expireContent = _.get(contentSettings, 'expireContent', false);
  
  return (
    <div className={styles.contentSettingsContainer}>
      <Row>
        <Col md={6}>
          <h4 className={styles.title}> Restrict Expired Assets </h4>
          <p className={styles.subText}>Automatically restrict the sharing of your expired assets.
            <SwitchButton className={styles.switchButton} id="shareReshare" handleCheck={() => onChange( "expireContent", !expireContent)} checked={expireContent} />
          </p>
          <p className={styles.note}>Note: This will remove previous share history and delete related conversations. Previous recipients will no longer be able to access the assets.</p>
        </Col>
      </Row>
    </div>
  )
}